import React from "react";
import Innerhtml from "../utils/Innerhtml";

export default function ClassListings({ data }) {
  const heading = data?.heading || "Our Classes";
  const subHeading = data?.subHeading || "";
  const content = data?.content || "";
  const media = data?.media || "";
  const imageUrl = media && media.trim().replace(/`/g, "") || "";

  // The rich `content` HTML may ship with a placeholder image; when a real
  // `media` URL is available, use it as the section's showcase image.
  const heroImage = imageUrl
    ? `<img src="${imageUrl}" alt="${heading.replace(/"/g, "&quot;")}" style="width:100%;max-width:560px;height:auto;border-radius:2px;display:block;margin-left:auto;" />`
    : "";
  const heroContent = content
    .replace(/<img[^>]*\/?>/i, heroImage)
    .trim();

  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 font-sans">
      {/* Section Header */}
      <div className="mb-8 sm:mb-12">
        <h2 className="text-center text-3xl sm:text-4xl font-bold text-gray-900">{heading}</h2>
        {subHeading && (
          <p className="text-center mt-4 text-gray-600 leading-relaxed">{subHeading}</p>
        )}
      </div>

      {/* Hero Content (two-column, responsive via Innerhtml) */}
      <Innerhtml data={heroContent} />
    </section>
  );
}